// extracted by mini-css-extract-plugin
export default {"preloader":"vKYQWZ1Z8r1V0yAN6pzI","preloaderSpinner":"klKmqbjUAUEkpXu4hni9","spin":"gP6CaIfO2DizvShkbHOQ"};